require("../../../assets/scss/main.global.scss")


import {Component} from '@angular/core';
//import {RouteConfig, ROUTER_DIRECTIVES} from '@angular/router-deprecated';
import {NgIf} from '@angular/common';
import {Router,NavigationStart} from '@angular/router'
import {EventListComponent} from '../event-components/event-list/event-list.component';
//import {SeatingplanListComponent} from '../seatingplan-components/seatingplan-list/seatingplan-list.component.ts';
//import {SeatingplanFormComponent} from '../seatingplan-components/seatingplan/seatingplan.component.ts';
//import {ShopComponent} from '../shop-components/shop.component.ts';
//import {CheckoutComponent} from '../checkout-components/checkout.component'

import {HeaderComponent} from '../header-components/header.component'
import {NavigationComponent} from '../navigation-components/navigation.component'
import {MessagesComponent} from "../messages/messages.component"
import {Store} from "@ngrx/store";
import {AppState} from "../../reducers";
import {OauthHelper} from '../../services/webservice/oauth-helper.service';
import {JwtHelper} from 'angular2-jwt';
import { RoutingActions, AppActions } from "../../actions";
@Component({
	selector: 'merchant-ui',
	templateUrl: "./merchant-ui.html",
	styles: [require("./merchant-ui.scss")]
})

/*@RouteConfig([
	{ path: '/event-list', name: 'EventList', data: { name: "EventList" }, component: EventListComponent, useAsDefault: true },
	{ path: '/event/...', name: 'Event', data: { name: "Event" }, component: EventComponent },
	{ path: '/venue-list', name: 'VenueList', data: { name: "VenueList" }, component: VenueListComponent },
	{ path: '/venue/...', name: 'Venue', data: { name: "Venue" }, component: VenueComponent },
	{ path: '/seatingplan-list', name: 'SeatingplanList', data: { name: "SeatingplanList" }, component: SeatingplanListComponent },
	{ path: '/seatingplan/:id', name: 'Seatingplan', data: { name: "Seatingplan" }, component: SeatingplanFormComponent },
	{ path: '/event-status', name: 'EventStatusList', data: { name: "EventStatusList" }, component: EventStatusListComponent },
	{ path: '/shop/...', name: 'Shop', data: { name: "Shop" }, component: ShopComponent },
	{ path: '/checkout/...', name: 'Checkout', data: { name: "Checkout" }, component: CheckoutComponent }
])
*/
export class MerchantUiComponent {

	//private jwtHelper: JwtHelper = new JwtHelper();
	constructor(
		private routingActions: RoutingActions,
		private appActions: AppActions,
		private jwtHelper: JwtHelper,
		private router: Router,
		private store:Store<AppState>,
		private oauthHelper: OauthHelper) {
		oauthHelper.handleOauthResponse();
		if (!this.isLoggedIn()) {
			this.login();
		} else {
			this.store.dispatch(this.appActions.userLoggedIn())
		}

		router.events.subscribe((event) => {
			if (event instanceof NavigationStart) {
				this.store.dispatch(this.routingActions.routingStart(event));
				window.scrollTo(0, 0);
			}
		})
	}

	login() {
		let clientId = "login-client"
		let scope = "READ"
		let state = Math.floor((Math.random() * 10000) + 1);
		this.oauthHelper.saveStateNumber(state);
		let redirectUri = window.location.href;
		let loginUrl: string = ZUUL_BACKEND
			+ "/auth/oauth/authorize?response_type=token&client_id=" + clientId
			+ "&scope=" + scope
			+ "&state=" + state
			+ "&redirect_uri=" + redirectUri;
		window.location.href = loginUrl;
	}

	isLoggedIn(): boolean {
		if (this.oauthHelper.getAccessToken()) {
			return !this.jwtHelper.isTokenExpired(this.oauthHelper.getAccessToken());
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/merchant-ui/merchant-ui.component.ts